(() => {
  const normalise = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
  const initialise = root => {
    if (root.dataset.initialised) return;
    root.dataset.initialised = 'true';
    const cards = Array.from(root.querySelectorAll('[data-guide-card]'));
    const filters = Array.from(root.querySelectorAll('[data-guide-filter]'));
    const input = root.querySelector('[data-guide-search]');
    const status = root.querySelector('[data-guide-status]');
    const empty = root.querySelector('[data-guide-empty]');
    let category = 'all';
    const label = key => filters.find(button => button.dataset.guideFilter === key);
    cards.forEach(card => { card.searchText = normalise(card.textContent); });
    filters.forEach(button => {
      const key = button.dataset.guideFilter;
      const count = cards.filter(card => key === 'all' || card.dataset.guideCategories.split(' ').includes(key)).length;
      button.querySelector('[data-guide-count]').textContent = count;
      button.hidden = count === 0;
    });
    const update = () => {
      const words = normalise(input.value).split(/\s+/).filter(Boolean);
      let count = 0;
      cards.forEach(card => {
        const match = (category === 'all' || card.dataset.guideCategories.split(' ').includes(category)) && words.every(word => card.searchText.includes(word));
        card.hidden = !match;
        if (match) count += 1;
      });
      filters.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.guideFilter === category)));
      status.textContent = count + (count === 1 ? root.dataset.singular : root.dataset.plural);
      empty.hidden = count !== 0;
    };
    const fromURL = () => {
      const params = new URLSearchParams(location.hash.slice(1));
      category = label(params.get('categorie')) ? params.get('categorie') : 'all';
      input.value = params.get('cauta') || '';
      update();
    };
    const saveURL = () => {
      const params = new URLSearchParams();
      if (category !== 'all') params.set('categorie', category);
      if (input.value.trim()) params.set('cauta', input.value.trim());
      const hash = params.toString();
      history.replaceState(null, '', location.pathname + location.search + (hash ? '#' + hash : ''));
    };
    filters.forEach(button => button.addEventListener('click', () => { category = button.dataset.guideFilter; update(); saveURL(); }));
    input.addEventListener('input', () => { update(); saveURL(); });
    root.querySelector('[data-guide-reset]').addEventListener('click', () => { category = 'all'; input.value = ''; update(); saveURL(); input.focus(); });
    window.addEventListener('hashchange', fromURL);
    fromURL();
    root.querySelector('[data-guide-tools]').hidden = false;
  };
  const start = scope => scope.querySelectorAll('[data-rxs-guides]').forEach(initialise);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => start(document)); else start(document);
  document.addEventListener('shopify:section:load', event => start(event.target));
})();